(() => {
  if (window.__omOrderBenefitsCopyInitialized) {
    return;
  }

  window.__omOrderBenefitsCopyInitialized = true;

  async function copyCouponCode(code) {
    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {
      await navigator.clipboard.writeText(code);
      return;
    }

    const temporaryInput =
      document.createElement('textarea');

    temporaryInput.value = code;
    temporaryInput.setAttribute('readonly', '');
    temporaryInput.style.position = 'fixed';
    temporaryInput.style.opacity = '0';

    document.body.appendChild(temporaryInput);
    temporaryInput.select();

    document.execCommand('copy');
    temporaryInput.remove();
  }

  function showCopiedState(button) {
    const label = button.querySelector('span');

    if (!label) {
      return;
    }

    window.clearTimeout(button.omCopyResetTimer);

    button.classList.add('is-copied');
    label.textContent = 'Copied ✓';
    button.setAttribute('aria-label', 'Coupon code copied');

    button.omCopyResetTimer = window.setTimeout(() => {
      button.classList.remove('is-copied');
      label.textContent = 'Copy';

      const code =
        button.getAttribute('data-om-copy-code');

      button.setAttribute(
        'aria-label',
        `Copy coupon code ${code}`
      );
    }, 1800);
  }

  document.addEventListener('click', async (event) => {
    const copyButton = event.target.closest(
      '[data-om-copy-code]'
    );

    if (!copyButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const code =
      copyButton.getAttribute('data-om-copy-code');

    if (!code) {
      return;
    }

    try {
      await copyCouponCode(code);
      showCopiedState(copyButton);
    } catch (error) {
      console.error(
        'OM Order Benefits: Unable to copy coupon code.',
        error
      );
    }
  });
})();